import { ReactNode } from 'react';

import './styles.css';

/**
 * this is third party code provided by lendflow to match html.
 */
const PageStyles = ({ children }: { children: ReactNode }) => <div className="la-capital-page">{children}</div>;

export default PageStyles;
